(() => {
  const safeJsonParse = (value, fallback = {}) => {
    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  };

  const ensureScriptJson = (el) => {
    if (!el) return;
    if (el.querySelector("script")) return;
    const s = document.createElement("script");
    s.type = "application/json";
    s.textContent = "{}";
    el.appendChild(s);
  };

  // Fix: ProductPrice.updatePrices may assume nodes exist on all templates/blocks.
  customElements.whenDefined("product-price-element").then(() => {
    const Ctor = customElements.get("product-price-element");
    if (!Ctor || !Ctor.prototype) return;

    Ctor.prototype.updatePrices = function (variant) {
      if (!variant) {
        this.parentNode?.setAttribute("aria-hidden", true);
        return;
      }

      this.parentNode?.setAttribute("aria-hidden", false);

      if (this.price) this.price.innerHTML = this.formatMoney(this.productPrice);

      if (this.compare_price) {
        if (this.compareEnabled) {
          this.compare_price.innerHTML = this.formatMoney(this.compareAtPrice);
          this.compare_price.style.display = "inline-block";
        } else {
          this.compare_price.style.display = "none";
        }
      }

      const upm = variant.unit_price_measurement;
      if (upm) {
        if (this.unit_price) this.unit_price.innerHTML = this.formatMoney(variant.unit_price);
        if (this.reference_unit) this.reference_unit.innerHTML = upm.reference_unit;

        if (this.reference_value) {
          if (upm.reference_value === 1) {
            this.reference_value.style.display = "none";
          } else {
            this.reference_value.innerHTML = upm.reference_value;
            this.reference_value.style.display = "block";
          }
        }

        if (this.unit_price_container) this.unit_price_container.style.display = "flex";
      } else if (this.unit_price_container) {
        this.unit_price_container.style.display = "none";
      }
    };
  });

  // Fix: FeedbackBar expects an inline JSON <script>.
  customElements.whenDefined("feedback-bar-element").then(() => {
    const Ctor = customElements.get("feedback-bar-element");
    if (!Ctor || !Ctor.prototype) return;

    const orig = Ctor.prototype.connectedCallback;
    Ctor.prototype.connectedCallback = function () {
      ensureScriptJson(this);
      const script = this.querySelector("script");
      if (script && !this.message_json) this.message_json = safeJsonParse(script.textContent, {});
      return orig ? orig.call(this) : undefined;
    };
  });

  // Fix: ProductBuyButtons expects an inline JSON <script> with translations.
  customElements.whenDefined("product-buy-buttons-element").then(() => {
    const Ctor = customElements.get("product-buy-buttons-element");
    if (!Ctor || !Ctor.prototype) return;

    const orig = Ctor.prototype.connectedCallback;
    Ctor.prototype.connectedCallback = function () {
      ensureScriptJson(this);
      const script = this.querySelector("script");
      if (script && !this.translations) this.translations = safeJsonParse(script.textContent, {});
      return orig ? orig.call(this) : undefined;
    };
  });

  // Fix: Sometimes the primary ATC button gets stuck in aria-busy="true"
  // (spinner state) after AJAX add-to-cart. Reset it whenever the cart updates.
  const resetStuckBuyButtons = () => {
    document
      .querySelectorAll('.product-buy-buttons--primary[aria-busy="true"]')
      .forEach((btn) => btn.setAttribute("aria-busy", "false"));
  };

  const bindBusyResets = () => {
    [
      "theme:cart:updated",
      "slidecart:refresh",
      "cart:refresh",
      "cart:updated",
      "cart:change"
    ].forEach((evt) => {
      window.addEventListener(evt, resetStuckBuyButtons, { passive: true });
      document.addEventListener(evt, resetStuckBuyButtons, { passive: true });
    });

    // As a last resort, if a click triggers busy and the cart event never fires,
    // clear the spinner after a short delay.
    document.addEventListener(
      "click",
      (e) => {
        const btn = e.target?.closest?.(".product-buy-buttons--primary");
        if (!btn) return;
        if (btn.getAttribute("aria-busy") !== "true") return;
        window.setTimeout(() => {
          if (btn.isConnected && btn.getAttribute("aria-busy") === "true") {
            btn.setAttribute("aria-busy", "false");
          }
        }, 6000);
      },
      { capture: true, passive: true }
    );

    // ProductBuyButtons sets aria-busy during form submit (not necessarily on click),
    // so also guard via submit capture.
    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        const host = form.querySelector("product-buy-buttons-element");
        if (!host) return;

        const btn = host.querySelector(".product-buy-buttons--primary");
        if (!btn) return;

        // Give the theme handler time to set aria-busy.
        window.setTimeout(() => {
          if (btn.getAttribute("aria-busy") !== "true") return;

          // If it stays stuck, clear it.
          window.setTimeout(() => {
            if (btn.isConnected && btn.getAttribute("aria-busy") === "true") {
              btn.setAttribute("aria-busy", "false");
            }
          }, 4000);
        }, 0);
      },
      { capture: true }
    );
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindBusyResets, { once: true });
  } else {
    bindBusyResets();
  }
})();

